import { render, staticRenderFns } from "./StatisticsChart.vue?vue&type=template&id=0fef010e&scoped=true"
import script from "./StatisticsChart.vue?vue&type=script&lang=js"
export * from "./StatisticsChart.vue?vue&type=script&lang=js"
import style0 from "./StatisticsChart.vue?vue&type=style&index=0&id=0fef010e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fef010e",
  null
  
)

export default component.exports